var render, staticRenderFns
import script from "./icon.vue?vue&type=script&lang=tsx&"
export * from "./icon.vue?vue&type=script&lang=tsx&"
import style0 from "./icon.vue?vue&type=style&index=0&id=a5670b5a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5670b5a",
  null
  
)

export default component.exports